<template>
	<div class="head">
		<el-tabs v-model="editableTabsValue" type="card" @tab-click="tabClick">
			<el-tab-pane :key="index" v-for="(item, index) in getList()"
				:label="item.languageName" :name="item.languageName">
				<el-form v-if="item.languageName == editableTabsValue" ref="form" :model="textForm" label-width="80px">
					<el-form-item label="文本内容">
						<wang-editor :htmlText="getHtml(item)" @onChange="onChange($event,item)"></wang-editor>
					</el-form-item>
				</el-form>
			</el-tab-pane>
		</el-tabs>
		<div style="width: 100%;display: flex;justify-content: flex-end;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelText">取 消</el-button>
				<el-button style="background-color: #8c62ff ;color: #ffffff;" @click="confirmText">确 定</el-button>
			</span>
		</div>
	</div>
</template>

<script>
	import wangEditor from './wangEditor.vue'
	export default {
		components: {
			wangEditor
		},
		props: {
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				show: true,
				tabIndex: 2,
				editableTabsValue: '中文',
				textForm: {

				}
			}
		},
		mounted() {
			this.selectdItem.compontChildren[0].data.text.list.forEach(item => {
				if(item.language == this.systemConfig.locale) {
					this.editableTabsValue = item.languageName
				}
			})
		},
		methods: {
			getList() {
				let arr = []
				let topItem;
				this.selectdItem.compontChildren[0].data.text.list.forEach(item => {
					this.systemConfig.locale_list.forEach(langItem => {
						if(item.language == this.systemConfig.locale) {
							topItem = item
							
						}else {
							if (item.language == langItem.code) {
								arr.push(item)
							}
						}
					})
				})
				arr.unshift(topItem)
				console.log('arr',arr)
				return arr
			},
			tabClick(e) {
				console.log('tabClick e', e)
				this.show = false
				this.$nextTick(() => {
					this.show = true
				})
			},
			confirmText() {
				this.$emit('confirmText', this.textForm)
			},
			cancelText() {
				this.$emit('cancelText')
			},
			getHtml(item) {
				if (item.languageName == this.editableTabsValue) {
					console.log('getHtml', item)
					return item.text
				}
			},
			onChange(e, item) {
				console.log('onChangeonChange e', e)
				console.log('onChangeonChange e', item)
				console.log('textForm', this.textForm)
				item.text = e
				this.textForm[item.language] = e


			},
			isNeedText(e) {
				let text = ''
				e.forEach(item => {
					if (item.text != '') {
						text = item.text
					}
				})
				return text
			},
			handleTabsEdit(e) {
				console.log('handleTabsEdite', e)
			},
			cancel() {

			},
			confirm() {

			}
		}
	}
</script>

<style scoped lang="scss">
	.el-button:hover {
		background-color: #fbf6ff;
		opacity: 0.7;
		color: #8c62ff;
	}

	.head {
		input:focus {
			outline: none;
			border: 1px solid #8c62ff;
			border-radius: 3px;
		}

		::v-deep .el-tabs__item {
			height: 34px;
			color: #000000;
			// font-weight: bold;
		}

		::v-deep .el-select .el-input__inner:focus {
			border: 1px solid #8c62ff;
		}

		::v-deep .is-active {
			color: #8C62FF;
		}
	}
</style>